
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-black/95 backdrop-blur-lg shadow-2xl shadow-cyan-500/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center cursor-pointer group" onClick={() => scrollToSection('home')}>
            <img
              src="https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/b468e3fbe55eb15f4444c0166571278a.png"
              alt="HAUL IT ALL"
              className="h-16 w-auto transition-transform duration-300 group-hover:scale-105 drop-shadow-[0_0_15px_rgba(6,182,212,0.5)]"
            />
          </div>

          <div className="hidden md:flex items-center space-x-1">
            {['home', 'services', 'booking', 'about', 'contact', 'reviews', 'gallery'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item)}
                className={`relative px-4 py-2 text-sm font-medium tracking-wider uppercase transition-all duration-300 whitespace-nowrap cursor-pointer group ${
                  isScrolled ? 'text-gray-300 hover:text-cyan-400' : 'text-white hover:text-cyan-400'
                }`}
                style={{ fontFamily: 'Rajdhani, sans-serif' }}
              >
                {item}
                <span className="absolute bottom-0 left-1/2 w-0 h-0.5 bg-gradient-to-r from-cyan-400 to-blue-500 transition-all duration-300 group-hover:w-full group-hover:left-0"></span>
              </button>
            ))}
            <a
              href="tel:9513509072"
              className="ml-4 bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-6 py-2.5 rounded-md text-sm font-bold tracking-wider hover:from-cyan-400 hover:to-blue-500 transition-all duration-300 shadow-lg shadow-cyan-500/30 hover:shadow-cyan-500/50 whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
            >
              (951) 350-9072
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-white' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur-lg border-t border-cyan-500/20">
          <div className="px-4 py-4 space-y-1">
            {['home', 'services', 'booking', 'about', 'contact', 'reviews', 'gallery'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item)}
                className="block w-full text-left text-gray-300 hover:text-cyan-400 font-medium py-2 uppercase tracking-wider cursor-pointer transition-colors"
                style={{ fontFamily: 'Rajdhani, sans-serif' }}
              >
                {item}
              </button>
            ))}
            <a
              href="tel:9513509072"
              className="block bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-6 py-3 rounded-md text-sm font-bold text-center mt-4 cursor-pointer"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
            >
              (951) 350-9072
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
